/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CountryDto,
  LoginRequestDto,
  Person,
  PersonSearchResponseDto,
  PersonUpdateDto,
  RefreshRequestDto,
} from '../models/index';
import {
    CountryDtoFromJSON,
    CountryDtoToJSON,
    LoginRequestDtoFromJSON,
    LoginRequestDtoToJSON,
    PersonFromJSON,
    PersonToJSON,
    PersonSearchResponseDtoFromJSON,
    PersonSearchResponseDtoToJSON,
    PersonUpdateDtoFromJSON,
    PersonUpdateDtoToJSON,
    RefreshRequestDtoFromJSON,
    RefreshRequestDtoToJSON,
} from '../models/index';

export interface ApiPersonIgvRequestGetRequest {
    igvKennung?: number;
    vorname?: string;
    nachname?: string;
    ort?: string;
    gebDat?: Date;
}

export interface ApiPersonLoginPostRequest {
    loginRequestDto?: LoginRequestDto;
}

export interface ApiPersonMePutRequest {
    personUpdateDto?: PersonUpdateDto;
}

export interface ApiPersonRefreshPostRequest {
    refreshRequestDto?: RefreshRequestDto;
}

export interface ApiPersonRegisterRegisterIdGetRequest {
    registerId: string;
}

export interface ApiPersonSearchGetRequest {
    q?: string;
}

/**
 * 
 */
export class PersonApi extends runtime.BaseAPI {

    /**
     */
    async apiPersonCountriesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CountryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryDtoFromJSON));
    }

    /**
     */
    async apiPersonCountriesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CountryDto>> {
        const response = await this.apiPersonCountriesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonIgvRequestGetRaw(requestParameters: ApiPersonIgvRequestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['igvKennung'] != null) {
            queryParameters['igvKennung'] = requestParameters['igvKennung'];
        }

        if (requestParameters['vorname'] != null) {
            queryParameters['vorname'] = requestParameters['vorname'];
        }

        if (requestParameters['nachname'] != null) {
            queryParameters['nachname'] = requestParameters['nachname'];
        }

        if (requestParameters['ort'] != null) {
            queryParameters['ort'] = requestParameters['ort'];
        }

        if (requestParameters['gebDat'] != null) {
            const d = requestParameters['gebDat'] as any
            const yyyy = d.getFullYear()
            const mm = String(d.getMonth() + 1).padStart(2, '0')
            const dd = String(d.getDate()).padStart(2, '0')
            queryParameters['gebDat'] = `${yyyy}-${mm}-${dd}`
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/igv-request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiPersonIgvRequestGet(requestParameters: ApiPersonIgvRequestGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPersonIgvRequestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonLoginPostRaw(requestParameters: ApiPersonLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Person>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestDtoToJSON(requestParameters['loginRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonLoginPost(requestParameters: ApiPersonLoginPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Person> {
        const response = await this.apiPersonLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonMePutRaw(requestParameters: ApiPersonMePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/me`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PersonUpdateDtoToJSON(requestParameters['personUpdateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPersonMePut(requestParameters: ApiPersonMePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPersonMePutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPersonRefreshPostRaw(requestParameters: ApiPersonRefreshPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshRequestDtoToJSON(requestParameters['refreshRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPersonRefreshPost(requestParameters: ApiPersonRefreshPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPersonRefreshPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPersonRegisterRegisterIdGetRaw(requestParameters: ApiPersonRegisterRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling apiPersonRegisterRegisterIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/register/{RegisterId}`.replace(`{${"RegisterId"}}`, encodeURIComponent(String(requestParameters['registerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonRegisterRegisterIdGet(requestParameters: ApiPersonRegisterRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Person> {
        const response = await this.apiPersonRegisterRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonSearchGetRaw(requestParameters: ApiPersonSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonSearchResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonSearchResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonSearchGet(requestParameters: ApiPersonSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonSearchResponseDto> {
        const response = await this.apiPersonSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
